import type { Column } from '@/components/Organisms/DataTable/DataTable.types';

export const moduleFilterOptions = [
	{ label: 'All', value: '' },
	{ label: 'Front End', value: 'Front End' },
	{ label: 'Backend', value: 'Backend' },
];
export const allModules = [
	{ label: 'All', value: '' },
	{ label: 'Benefits Verification', value: 'Benefits Verification' },
	{ label: 'Consignment Orders', value: 'Consignment Orders' },
	{ label: 'Return Orders', value: 'Return Orders' },
	{ label: 'Invoices', value: 'Invoices' },
	{ label: 'Patients', value: 'Patients' },
	{ label: 'Users', value: 'Users' },
	{ label: 'Support Tickets', value: 'Support Tickets' },
];

export const appCrashReportColumns: Column[] = [
	{
		key: 'type',
		label: 'Type',
		width: '80px',
		type: 'string-status',
	},
	{
		key: 'moduleName',
		label: 'Module Name',
		width: '120px',
		type: 'string-status',
	},
	{
		key: 'userName',
		label: 'User Name',
		width: '120px',
	},
	{
		key: 'createdAt',
		label: 'Timestamp',
		width: '160px',
	},
	{
		key: 'method',
		label: 'Method',
		width: '80px',
	},
	{
		key: 'serviceName',
		label: 'Service Name',
		width: '150px',
	},
	{
		key: 'errorMessage',
		label: 'Error Message',
		width: '120px',
	},
	{
		key: 'userAgent',
		label: 'User Agent',
		width: '120px',
	},
	{
		key: 'environment',
		label: 'Environment',
		width: '100px',
	},
];

export const ENV_MAP: Record<string, string> = {
	development: 'QA',
	develop: 'QA',
	stage: 'STAGE',
	preprod: 'PREPROD',
	prod: 'PROD',
};
